import React, { useEffect, useState } from 'react';
import CodingVariants from './view02/codingVariants';
import Genes from './view02/genes';
import PIP from './view02/PIP';
import * as d3 from "d3";

function View02 (props){

    const dna = props.dna,
        locus = props.locus,
        setLocus = props.setLocus,
        settings = props.settings,
        slot = props.slot,
        setSlot = props.setSlot,
        biobanksList = props.biobanks,
        format = props.format,
        chr = props.chr,
        pos = props.pos,
        wholeDataset = props.wholeDataset,
        defineMinPval = props.defineMinPval,
        types = props.types,
        ranges = props.ranges,
        PIPs = props.PIPs,
        extra = props.extra,
        codV = props.codV;

    const [palettes, setPalettes] = useState(false),
        [finemapping, setFinemapping] = useState(false);

    const size = {
        margin:{ 
            top: 20,
            left: 255,
            gutter: 6,
            bottom: 100,
        },
        width: props.width,
        height: 55,
        genes: 100,
    };

    const unit = size.margin.left/7
    const elements = wholeDataset[slot.chr-1][1].filter(el => el[pos] >= slot.low && el[pos] <= slot.high)
    const biobanks = biobanksList.map((bb,i) => ({
        biobank: bb, 
        minimum: defineMinPval(elements, bb),
        type: types[i]
        }))

    var viewMin = d3.min(biobanks, d => d.minimum)
    if (viewMin > 1e-7) viewMin= 1e-7

    const scalePosition = d3.scaleLinear()
        .domain([slot.low, slot.high])
        .range([size.margin.left, size.width])
        .clamp(true)

    function drawBiobankList (data) {

        d3.select('#biobanks02').selectAll('.item').data(data).join(
            function(enter){
                const item = enter.append('g')
                    .attr('class', 'item')
                    .style("transform", (d, i) => `translateY(${(i*size.height+size.margin.top+size.genes)}px)`)
                item.append('line')
                    .classed('normalLine', true)
                    .attr('x1', 0)
                    .attr('x2', size.margin.left - size.margin.gutter)
                    .attr('y1', size.height)
                    .attr('y2', size.height)
                item.append('text')
                    .attr('id', (d,i) => 'slot_BB_'+i)
                    .html(d => format('bb', d.biobank))
                    .attr('x', 0)
                    .attr('y', 20)
                    .classed('mediumText', true)
                    .classed('normalLine', false)
                
                const legenda = item.append('g')
                    .attr('class', 'legenda')
                    .style("transform", (d, i) => `translate(${unit}px, 45px)`)

                const gradient = legenda.append('defs').append('linearGradient')
                    .attr('id', (d,i) => 'lg_'+i)
                gradient.append('stop')
                    .attr('offset', '0%')
                    .attr('stop-color', d => settings.colors[d.type][0])
                gradient.append('stop')
                    .attr('class', 'maxStop')
                    .attr('offset', (d,i) => putTick('max', d.minimum, d.type, i, 'stop'))
                    .attr('stop-color', d => settings.colors[d.type][3])
                gradient.append('stop')
                    .attr('offset', '100%')
                    .attr('stop-color', d => settings.colors[d.type][3])
                legenda.append('rect')
                    .attr('x', 0)
                    .attr('y', 0)
                    .attr('width', 5*unit)
                    .attr('height', 4)
                    .attr('rx', 2)
                    .attr('fill', (d,i) => 'url(#lg_'+i+')')
                
                const minTick = legenda.append('g')
                    .attr('class', 'minTick')
                    .style("transform", (d, i) => putTick(d.minimum, d.minimum, d.type, i, 'tick'))
                minTick.append('line')
                    .attr('class', 'normalLine')
                    .attr('y1', 4)
                    .attr('y2', -3)
                    .attr('x1', 0)
                    .attr('x2', 0)
                minTick.append('text')
                    .html(d => format('pv', d.minimum))
                    .attr('x', 4)
                    .attr('y', -7)
                    .classed('smallText', true)
                    .style('text-anchor', 'end')

                const maxTick = legenda.append('g')
                    .attr('class', 'maxTick')
                    .style("transform", (d, i) => putTick('max', d.minimum, d.type, i, 'tick'))
                    .style('opacity', d => d.type === 'pvalue' && d.minimum >= 1e-7 ? 0 : 1)
                maxTick.append('line')
                    .attr('class', 'normalLine')
                    .attr('y1', 4)
                    .attr('y2', -3)
                    .attr('x1', 0)
                    .attr('x2', 0)
                maxTick.append('text')
                    .html((d,i) => getMaxPval(d.type, i))
                    .attr('x', -4)
                    .attr('y', -7)
                    .classed('smallText', true)
                    .style('text-anchor', 'start')
                
                return item
            },
            function(update){
                // update.select('.pv').html(d => format('pv', d.minimum))
                update.select('.maxStop').transition().duration(500)
                    .attr('offset', (d,i) => putTick('max', d.minimum, d.type, i, 'stop'))
                
                update.select('.maxTick').transition().duration(500)
                    .style("transform", (d, i) => putTick('max', d.minimum, d.type, i, 'tick'))
                
                update.select('.minTick').transition().duration(500)
                    .style("transform", (d, i) => putTick(d.minimum, d.minimum, d.type, i, 'tick'))
                    .style('opacity', d => d.type === 'pvalue' && d.minimum >= 1e-7 ? 0 : 1)
                
                update.select('.minTick').select('text').html(d => format('pv', d.minimum))
                update.select('.maxTick').select('text').html((d,i) => getMaxPval(d.type, i))
            }
        )
    };

    function moveSlot (side, action) {

        const delta = Math.round((slot.high-slot.low)*0.1);
        var low, high, expand;

        action ? expand = delta: expand = -delta;
        side === 'left' ? low = slot.low - expand : low = slot.low;
        side === 'right' ? high = slot.high + expand : high = slot.high;

        if (low < 0) low = 0
        if (high > dna[slot.chr-1].size) high = dna[slot.chr-1].size

        const newSlot = {
            chr: slot.chr,
            low: low,
            high: high,
        }

        function newBottomView(){
            setSlot(newSlot)
            setLocus({})
        }

        d3.selectAll('#position02, #view03').transition().duration(500).style('opacity', 0);
        setTimeout(newBottomView, 500)

    }

    function generateLocus (chromosome, position, locusLow, locusHigh) {

        if (locusLow === undefined) locusLow = position-20000
        if (locusHigh === undefined) locusHigh = position+20000

        const newLocus = {
            chr: chromosome,
            low: locusLow,
            high: locusHigh,
            pos: position,
        }

        setLocus(newLocus)
    }

    function getMaxPval (type, index) {
        if (type === 'nominal') return 1e-1
        else if (type === 'pvalue') {
            if (ranges[index][2] <= -8) return 1e-8
            else return 1e-7
        }
    }

    function putTick (datum, minimum, type, index, location) {
        const min = (type === 'pvalue' && !palettes) ? viewMin : minimum

        const scaleUI = d3.scalePow()
            .domain([Math.log10(min),1])
            .range([0.2*unit, 5*unit])
            .exponent(1.2);

        const scale100 = d3.scalePow()
            .domain([Math.log10(min),1])
            .range([2, 100])
            .exponent(1.2);

        var value

        if (type === 'pvalue') {
            datum === 'max' ? value = getMaxPval('pvalue', index) : value = datum
            if (minimum >= 1e-7 || minimum === undefined || minimum === null) {
                if (location === 'tick') return 'translateX(-100px)'
                else if (location === 'stop') return undefined
            } else {
                if (location === 'tick') return `translateX(${scaleUI(Math.log10(value))}px)`
                else if (location === 'stop') return scale100(Math.log10(value)) + '%'
            }
        }
        else if (type === 'nominal') {
            datum === 'max' ? value = 1e-1 : value = datum
            if (minimum >= 1e-1 || minimum === undefined || minimum === null) {
                if (location === 'tick') return 'translateX(-100px)'
                else if (location === 'stop') return undefined
            } else {
                if (location === 'tick') return `translateX(${scaleUI(Math.log10(value))}px)`
                else if (location === 'stop') return scale100(Math.log10(value)) + '%'
            }
        }
    }

    function colorRects (datum, minimum, type, index, location) {

        const min = palettes ? minimum : viewMin
        const max = getMaxPval(type, index)
        
        if (minimum >= max || datum >= max || minimum === undefined || minimum === null) return settings.colors[type][3]
        else if (isNaN(datum) || datum === undefined || datum === null) return settings.colors[type][3]
        else if (datum === minimum && location === 'track') return settings.pink0
        else if (type === 'pvalue') {
            
            const scalePvalue = d3.scalePow()
                .domain([Math.log10(min), Math.log10(max)])
                .range([settings.colors.pvalue[0], settings.colors.pvalue[3]])
                .exponent(1.2);

            return scalePvalue(Math.log10(datum))
        }
        else if (type === 'nominal') {

            const scaleNominal = d3.scalePow()
                .domain([Math.log10(minimum), Math.log10(max)])
                .range([settings.colors.nominal[0], settings.colors.nominal[3]])
                .exponent(1.2);

            return scaleNominal(Math.log10(datum))
        }
    }

    function drawPosition (position) {
        d3.select('#position02').transition().duration(500).style('opacity',1)

        const XlocusLow = scalePosition(position-20000),
              XlocusHigh = scalePosition(position+20000),
              XlocusPos = scalePosition(position);

        d3.selectAll('.clickLine')
            .attr('x1', XlocusPos)
            .attr('x2', XlocusPos)
            .style('opacity', 0)
                .transition().duration(1000)
                .attr('x1', XlocusLow)
                .attr('x2', XlocusHigh)
                .style('opacity', 1);

        d3.select('#clickBrush')
            .attr('x', XlocusPos)
            .attr('width', 0)
                .transition().duration(1000)
                .attr('x', XlocusLow-1)
                .attr('width', XlocusHigh-XlocusLow);
        
        d3.select('#dragCircle02_low').style('opacity', 0).attr('cx', XlocusPos).transition().duration(1000).attr('cx', XlocusLow).style('opacity', 1);
        d3.select('#dragCircle02_high').style('opacity', 0).attr('cx', XlocusPos).transition().duration(1000).attr('cx', XlocusHigh).style('opacity', 1);
        d3.select('#dragText02_low').style('opacity', 0).attr('x', XlocusPos).transition().duration(1000).attr('x', XlocusLow+10).style('opacity', 1);
        d3.select('#dragText02_high').style('opacity', 0).attr('x', XlocusPos).transition().duration(1000).attr('x', XlocusHigh-10).style('opacity', 1);
        d3.select('#locusCircle02').attr('cx', XlocusPos);
    }

    function drawTracks(data) {
        d3.select('#backgrounds02')
            .selectAll('.background')
            .data(data)
            .join('rect')
                .attr('class', 'background')
                .attr('x', size.margin.left)
                .attr('width', size.width - size.margin.left)
                .attr('y', (d,i) => i * size.height + size.margin.top + size.genes)
                .attr('height', size.height-0.5)
                .attr('fill', (d,i) => settings.colors[types[i]][3])

        d3.select("#tracks02")
            .selectAll('.track')
            .data(data)
            .join('g')
                .attr('class', 'track')
                .attr('id', (d, i) => `track02_${i}`)
                .style("transform", (d, i) => `translateY(${(i*size.height+size.margin.top+size.genes)}px)`)
                .on('mouseenter', (e,d) => d3.select('#slot_BB_'+biobanksList.indexOf(d)).style('fill', settings.pink1))
                .on('mouseleave', (e,d) => d3.select('#slot_BB_'+biobanksList.indexOf(d)).style('fill', settings.blue3))
    }

    function moveHoverLine (event) {
        const delta = -36
        if (event.clientX > size.margin.left - delta) {
            d3.select('#hoverLine02')
                .style('display', 'block')
                .attr('x1', event.clientX + delta)
                .attr('x2', event.clientX + delta);
        } else hideHoverLine()
    }

    function hideHoverLine () {
        d3.select('#hoverLine02')
        .style('display', 'none')
    }

    function drawThumbnail(data) {

        biobanks.forEach((item,n)=>{
            
            d3.select(`#track02_${n}`)
                .selectAll(".unit")
                .data(data, d => d[pos])
                .join(
                    function(enter){
                        enter.append('rect')
                            .attr('key', (d,i) => i)
                            .classed('minimum', d => d[item.biobank] === item.minimum)
                            .attr('class', 'unit')
                            .style('cursor', 'pointer')
                            .attr('height', size.height-0.5)
                            .attr('width', 2)
                            .attr('x', d => scalePosition(d[pos])-1)
                            .attr('y', 0)
                            .style('opacity', 0)
                            .on('click', (e, d) => {generateLocus(d[chr], d[pos]); drawPosition(d[pos])})
                            .transition().duration(500)
                                .attr('fill', d => colorRects(d[item.biobank], item.minimum, types[n], n, 'track'))
                                .style('opacity', 1)
                    },
                    function(update){
                        update
                            .classed('minimum', d => d[item.biobank] === item.minimum)
                            .on('mouseover', function(e,d) {
                                d3.select('#hoverLine02')
                                    .style('display', 'block')
                                    .attr('x1', scalePosition(d[pos]))
                                    .attr('x2', scalePosition(d[pos]));
                            })
                            .on('click', (e, d) => {generateLocus(d[chr], d[pos]); drawPosition(d[pos])})
                            .transition().duration(500)
                                .attr('fill', d => colorRects(d[item.biobank], item.minimum, types[n], n, 'track'))
                                .attr('x', d => scalePosition(d[pos])-1)
                    },
                    function(exit){
                        exit.transition().style('opacity', 0)
                            .transition().remove()
                    }
                )

            });

            d3.selectAll('.minimum').raise();
    }

    var dragLow = d3.drag()
        .on('start', function(e){
            d3.select('#dragText02_low').transition().attr('x', e.x-10)
        })
        .on('drag', function(e){
            d3.select(this).attr("cx", e.x);
            d3.selectAll('.clickLine').attr('x1', e.x);
            d3.select('#clickBrush').attr('x', e.x).attr('width', scalePosition(locus.high) - e.x)
            d3.select('#dragText02_low').attr('x', e.x-10).html(Math.round(scalePosition.invert(e.x)))
        })
        .on('end', function(e){
            d3.select('#dragText02_low').html(Math.round(scalePosition.invert(e.x))).transition().duration(500).attr('x', e.x+10)
            generateLocus(locus.chr, locus.pos, Math.round(scalePosition.invert(e.x)), locus.high)
        })

    var dragHigh = d3.drag()
        .on('start', function(e){
            d3.select('#dragText02_high').transition().attr('x', e.x+10)
        })
        .on('drag', function(e){
            d3.select(this).attr("cx", e.x);
            d3.selectAll('.clickLine').attr('x2', e.x);
            d3.select('#clickBrush').attr('width', e.x - scalePosition(locus.low))
            d3.select('#dragText02_high').attr('x', e.x+10).html(Math.round(scalePosition.invert(e.x)))
        })
        .on('end', function(e){
            d3.select('#dragText02_high').html(Math.round(scalePosition.invert(e.x))).transition().duration(500).attr('x', e.x-10)
            generateLocus(locus.chr, locus.pos, locus.low, Math.round(scalePosition.invert(e.x)))
        })

        drawBiobankList(biobanks)
        drawTracks(biobanksList)
        drawThumbnail(elements)

    useEffect(()=>{

        d3.select('#view02').transition().duration(500).style('opacity',1);
        d3.select('#dragCircle02_low').call(dragLow)
        d3.select('#dragCircle02_high').call(dragHigh)
        
    });

    return (
         <div id="view02" className="section">
            <div className="section_header">
                <div>
                    <h1>Slot view</h1>
                </div>
                <div 
                    className="section_header_buttons" 
                    style={{
                        width: size.width-size.margin.left,
                        justifyContent: 'flex-end',
                        }}>
                        <button className={finemapping ? "buttonPrimary" : undefined} onClick={() => setFinemapping(!finemapping)} style={{display: extra.pip ? 'block' : 'none'}}>Finemapping PIP</button>
                        <button className={palettes ? "buttonPrimary toggleLeft" : "toggleLeft"} onClick={() => setPalettes(true)}>Multiple P-value palettes</button>
                        <button className={palettes ? "toggleRight" : "buttonPrimary toggleRight"} onClick={() => setPalettes(false)}style={{marginRight: 15}}>Single P-value palette</button>
                </div>
            </div>
            <div className="section_content">
                <div className="section_title" style={{paddingLeft: size.margin.left}}>
                    <div className="section_title_inner" style={{width: size.width - size.margin.left}}>
                        <p className='smallText'>Chromosome {slot.chr}</p>
                    </div>
                    <div 
                        className="section_title_inner"
                        style={{
                            width: size.width - size.margin.left, 
                            justifyContent: 'space-between'
                        }}
                        >
                        <div style={{display: 'flex', alignItems: 'baseline'}}>
                            <button className='buttonSmall' style={{marginLeft: 0}} onClick={() => moveSlot('left', true)}>&#8249;</button>
                            <button className='buttonSmall' onClick={() => moveSlot('left', false)}>&#8250;</button>
                            <p className='smallText' style={{marginLeft: 8}}>{slot.low}</p>
                        </div>
                        <div style={{display: 'flex', alignItems: 'baseline'}}>
                            <p className='smallText' style={{marginRight: 8}}>{slot.high}</p>
                            <button className='buttonSmall' onClick={() => moveSlot('right', false)}>&#8249;</button>
                            <button className='buttonSmall' onClick={() => moveSlot('right', true)}>&#8250;</button>
                        </div>
                    </div>
                </div>
                <svg 
                    id="chart02" 
                    width={size.width} 
                    height={biobanks.length*size.height + size.margin.top + size.margin.bottom + 20}
                    onMouseMove={e => moveHoverLine(e)}
                    onMouseLeave={() => hideHoverLine()}
                    >
                    <g id="title02">
                        <text x={0}                                      y={size.margin.top + size.genes- 10}    className='smallText'>Tracks</text>
                        <text x={size.margin.left - size.margin.gutter}  y={size.margin.top/2+3}                 className='smallText' style={{textAnchor: 'end'}}>Special coding variants</text>
                        <text x={size.margin.left - size.margin.gutter}  y={size.margin.top + size.genes/2+3}    className='smallText' style={{textAnchor: 'end'}}>Genes</text>
                    </g>
                    <g id="lines02">
                        <line x1={size.margin.left} x2={size.width}                            y1={1}                                   y2={1}                                className='normalLine'></line>
                        <line x1={size.margin.left} x2={size.width}                            y1={size.margin.top}                     y2={size.margin.top}                    className='normalLine'></line>
                        <line x1={size.margin.left} x2={size.width}                            y1={size.margin.top + size.genes -1.5}   y2={size.margin.top + size.genes -1.5}  className='thickLine'></line>
                        <line x1={0}                x2={size.margin.left - size.margin.gutter} y1={size.margin.top + size.genes -1.5}   y2={size.margin.top + size.genes -1.5}  className='thickLine'></line>
                    </g>
                    <g id="biobanks02" />
                    <g id="thumbnail02">
                        <g id="backgrounds02"/>
                        <g id="tracks02"/>
                        {extra.pip && (<PIP 
                            pos={pos}
                            chr={chr}
                            size={size}
                            elements={elements}
                            biobanks={biobanks}
                            scalePosition={scalePosition}
                            drawPosition={drawPosition}
                            generateLocus={generateLocus}
                            finemapping={finemapping}
                            format={format}
                            PIPs={PIPs}
                        />)}
                    </g>
                    <Genes
                        slot={slot}
                        size={size}
                        locus={locus}
                        settings={settings}
                        scalePosition={scalePosition}
                        />
                    <CodingVariants 
                        pos={pos}
                        slot={slot}
                        size={size}
                        locus={locus}
                        settings={settings}
                        elements={elements}
                        codV={codV}
                        scalePosition={scalePosition}
                        />
                    {Object.keys(locus).length > 0 && (
                        <g id="position02">
                            <line id="hoverLine02" className="hoverLine" style ={{display:"none"}} y1={1} y2={biobanks.length*size.height+size.margin.top+size.margin.bottom-1}></line>
                            <line className="clickLine" x1={scalePosition(locus.low)} x2={scalePosition(locus.high)} y1={biobanks.length*size.height+size.margin.top+size.margin.bottom+2.5} y2={biobanks.length*size.height+size.margin.top+size.margin.bottom+2.5} />
                            <line className="clickLine" x1={scalePosition(locus.low)} x2={scalePosition(locus.high)} y1={1} y2={1}  />
                            <rect id="clickBrush" y={1} height={biobanks.length*size.height+size.margin.bottom+size.margin.top+2.5} x={scalePosition(locus.low)} width={scalePosition(locus.high) - scalePosition(locus.low)}></rect>
                            <g>
                                {/* <path id="linkLine02_a"     className="linkLine"></path> */}
                                <circle id="dragCircle02_low" className="dragCircle" cy={size.margin.top+biobanks.length*size.height+size.margin.bottom+2.5} cx={scalePosition(locus.low)}></circle>
                                <text id="dragText02_low"     className='smallText' style={{textAnchor: 'end'}} y={size.margin.top+biobanks.length*size.height+size.margin.bottom+18} x={scalePosition(locus.low)}>{locus.low}</text>
                            </g>
                            <g>
                                {/* <path id="linkLine02_b"     className="linkLine"></path> */}
                                <circle id="dragCircle02_high" className="dragCircle" cy={size.margin.top+biobanks.length*size.height+size.margin.bottom+2.5} cx={scalePosition(locus.high)}></circle>
                                <text id="dragText02_high"     className='smallText' style={{textAnchor: 'start'}} y={size.margin.top+biobanks.length*size.height+size.margin.bottom+18} x={scalePosition(locus.high)}>{locus.high}</text>
                            </g>
                            <circle id="locusCircle02" r={3} cy={size.margin.top+biobanks.length*size.height+3} fill={settings.pink0} cx={-3}></circle>
                        </g>
                    )}
                </svg>
            </div>
        </div> 
        )
}
export default View02;